// Report-specific formatting configurations
// Each report can have custom column definitions, row styling, and layout options

export const reportFormatters = {
  // GL Report formatter
  'GL Report': {
    // Column customizations
    columnConfig: {
      'Account#': {
        width: 100,
        align: 'left',
        format: (value) => value,
      },
      'Account Description': {
        width: 250,
        align: 'left',
        format: (value) => value,
      },
      'Fee Description': {
        width: 200,
        align: 'left',
        format: (value) => value,
      },
      'Qty': {
        width: 80,
        align: 'center',
        format: (value) => value,
      },
      'Local Share': {
        width: 140,
        align: 'right',
        format: (value) => {
          if (value == null || value === '') return value;
          const num = parseFloat(value);
          if (isNaN(num)) return value;
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(Math.abs(num));
        },
        isCurrency: true,
      },
      // Hide internal row type and sort columns
      '_row_type': {
        display: 'none',
        width: 0,
      },
      '_sort_code': {
        display: 'none',
        width: 0,
      },
    },
    
    // Row styling rules specific to GL Report
    getRowStyle: (record) => {
      const rowType = record._row_type;
      
      // GRAND TOTAL - most prominent
      if (rowType === 'grand_total') {
        return {
          className: 'table-row-gl-grand-total',
          style: {
            fontWeight: 700,
            fontSize: 15,
            backgroundColor: '#1890ff',
            color: 'white',
          }
        };
      }
      
      // Sub-totals
      if (rowType === 'subtotal') {
        return {
          className: 'table-row-gl-subtotal',
          style: {
            fontWeight: 600,
            fontSize: 13,
            backgroundColor: '#e6f7ff',
            borderTop: '1px solid #1890ff',
            borderBottom: '1px solid #1890ff',
          }
        };
      }
      
      // Regular detail rows
      return {};
    },
    
    // Special handling for header result sets
    showHeaders: true,
    headerStyle: {
      backgroundColor: '#fafafa',
      padding: '16px',
      border: '1px solid #d9d9d9',
      borderRadius: '6px',
      marginBottom: '16px',
    },
    
    // Pagination and sizing
    pagination: false,
    scroll: { x: 'max-content' },
    size: 'small',
  },

  // Template for other custom reports
  'Sample Custom Report': {
    columnConfig: {
      // Define custom column configurations here
      'ColumnName': {
        width: 150,
        align: 'center',
        format: (value) => value,
      }
    },
    getRowStyle: (record) => {
      // Custom row styling logic
      return {};
    },
    showHeaders: true,
    pagination: true,
    scroll: { x: 'max-content' },
    size: 'middle',
  },
};

// Get formatter for a report
export const getReportFormatter = (reportTitle) => {
  return reportFormatters[reportTitle] || null;
};

// Check if a custom formatter exists
export const hasCustomFormatter = (reportTitle) => {
  return !!reportFormatters[reportTitle];
};
